/* eslint-disable */
export const maxLifetime = 0

export default [
[ 0, 100000 ],
[ 1, 79292 ],
[ 2, 75573 ],
[ 3, 74017 ],
[ 4, 73037 ],
[ 5, 72284 ],
[ 10, 70150 ],
[ 15, 68637 ],
[ 20, 63335 ],
[ 25, 57014 ],
[ 30, 51501 ],
[ 35, 46643 ],
[ 40, 42652 ],
[ 45, 39275 ],
[ 50, 36012 ],
[ 55, 32573 ],
[ 60, 28499 ],
[ 65, 23663 ],
[ 70, 17998 ],
[ 75, 12186 ],
[ 80, 6822 ],
[ 85, 0 ],
[ 90, 0 ],
[ 95, 0 ],
[ 100, 0 ],
[ 105, 0 ],
[ 110, 0 ]
]
